module.exports = new __parcel__URL__("tmp-epic-panel-details.tpl.a8264571.svg").toString();